import { render, staticRenderFns } from "./OrderInlineItemsList.vue?vue&type=template&id=02b7d843&scoped=true&"
import script from "./OrderInlineItemsList.vue?vue&type=script&lang=js&"
export * from "./OrderInlineItemsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderInlineItemsList.vue?vue&type=style&index=0&id=02b7d843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b7d843",
  null
  
)

export default component.exports